export const makeShorter = (sentence, size) => {
    let desc = sentence || '' ;
    let length = size || 0;
    let shortDesc = desc.substr(0, length);
    shortDesc = shortDesc.substr(0, Math.min(shortDesc.length, shortDesc.lastIndexOf(" ")));
    return shortDesc;
}
